import { create } from "apisauce";
const baseURL = process.env.REACT_APP_BASE_URL;
const apiClient = create({
  baseURL: baseURL,
});
const authToken = localStorage.getItem(process.env.REACT_APP_TOKEN);

console.log(authToken,"token");
if (authToken) apiClient.setHeader("Authorization", `Token ${authToken}`);
function setAuthToken(token) {
  apiClient.setHeader("Authorization", `Token ${token}`);
}

export { setAuthToken };
export default apiClient;
